import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import SiteList from "components/SiteList";
import { ModuleMap, ModuleValue } from "common/modules";

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

var siteStatusRenderer = function(params) {
	if (params.value == "SUCCESS") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(17, 119, 51);">Success</div>';
	} else if (params.value == "FAILED") {
		return '<div data-show="true" class="ant-tag ant-tag-has-color" style="background-color: rgb(217, 33, 32);">Failed</div>';
	} else if (params.value == "NONE") {
		return "";
	} else if (params.value == "RUNNING") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(16, 142, 233);">Running</div>';
	} else {
		return "<span></span>";
	}
};

function strcmp(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

@inject("rootStore")
@observer
class SitesTab extends Component {
	createColumnDefs(props) {
		return [
			{
				headerName: "Module",
				field: "id.module",
				valueFormatter: moduleFormatter,
				editable: false,
				hide: false,
				rowGroupIndex: 0
			},
			{
				headerName: "Platform",
				field: "platform",
				editable: false,
				hide: false,
				rowGroupIndex: 1
			},
			{
				field: "id",
				headerName: "ID",
				editable: false,
				hide: true
			},
			// {
			// 	headerName: "Site",
			// 	field: "id.siteId",
			// 	width: 267,
			// 	editable: false,
			// 	filter: "agTextColumnFilter"
			// 	// filter: getTextFilter()
			// 	// checkboxSelection: function(params) {
			// 	// 	return (
			// 	// 		params.columnApi.getRowGroupColumns().length === 0
			// 	// 	);
			// 	// },
			// },
			{
				headerName: "Status",
				field: "status",
				width: 150,
				editable: false,
				cellRenderer: siteStatusRenderer,
				filter: "agSetColumnFilter",
				filterParams: {
					values: ["NONE", "SUCCESS", "FAILED", "RUNNING"]
				},
				// checkboxSelection: function(params) {
				// 	return (
				// 		params.columnApi.getRowGroupColumns().length === 0
				// 	);
				// },
				cellClass: function() {
					return "alphabet";
				}
			},
			// {
			// 	headerName: "Game Name",
			// 	field: "game.name",
			// 	width: 267,
			// 	editable: false,
			// 	filter: "agSetColumnFilter",
			// 	tooltipField: "gameName",
			// 	// checkboxSelection: function(params) {
			// 	// 	return (
			// 	// 		params.columnApi.getRowGroupColumns().length === 0
			// 	// 	);
			// 	// },
			// 	cellClass: function() {
			// 		return "alphabet";
			// 	}
			// },
			{
				headerName: "DA",
				field: "pr",
				width: 100,
				editable: false,
				floatCell: true,
				filter: "agNumberColumnFilter",
				filterParams: {
					filterOptions: ["greaterThanOrEqual"],
					cellHeight: 20,
					newRowsAction: "keep"
				}
			},
			{
				headerName: "Dofollow",
				field: "dofollow",
				width: 150,
				editable: false,
				cellRenderer: doFollowRenderer,
				filter: "agSetColumnFilter"
			},
			{
				headerName: "Progress",
				field: "waitInfo",
				width: 250,
				editable: false,
				suppressFilter: true,
				suppressMenu: true,
				suppressSorting: true
			}
		];
	}

	getRowNodeId = (data) => {
		return data.id.module + "_" + data.siteId;
	}

	getRowData = () => {
		return this.siteList.getRowData();
	}

	render() {
        // console.log("Rendering sites tab");
		const {
			rootStore: { acProjectStore }
		} = this.props;				
		return (
			<div
				style={{
					width: "100%",
					height: window.screen.height * 3 / 4
				}}
			>
				<SiteList
					ui={acProjectStore.ui}
					sites={acProjectStore.sites.slice()}
					columnDefs={this.createColumnDefs()}
					getRowNodeId={this.getRowNodeId}
					ref={siteList => {
						this.siteList = siteList;
					}}
				/>
			</div>
		);
	}
}

export default SitesTab;

